define([],
    function () {
        let format = (page, curr) => `<a class="${ page === "..." ? "dots_js table-pagination__dots" : ""} table-pagination__page ${curr ? "disabled" : ""}" data-page="${page}"><span>${page}</span></a>`;
        let formatPrevNext = (direction, disabled) => `<a class="table-pagination__dir ${disabled ? "gray" : ""}" data-page="${direction}"><span>${direction === "<" ? "Prev" : "Next"}</span></a>`;

        return function initPagination(DOMEl, cb) {

            var payload = {page: 1, numPages: 1, offset: 3};

            DOMEl.wrap.classList.remove("disabled");

            DOMEl.wrap.addEventListener("click", function (e) {

                var page = "";
                var target = e.target;
                switch (target.tagName) {
                    case "SPAN": {
                        page = target.parentNode.getAttribute("data-page");
                        break;
                    }
                    case "A": {
                        page = target.getAttribute("data-page");
                        break;
                    }
                    case "DIV": {
                        return;
                    }
                }

                switch (page) {
                    case "<": {
                        page = payload.page - 1;
                        break;
                    }
                    case ">": {
                        page = (payload.page * 1) + 1;
                        break;
                    }
                    case "...": {
                        return;
                    }
                }

                cb(page * 1);

            });

            function update() {

                let count = payload.numPages;
                let current = payload.page;

                let leftDots = "";
                let rightDots = "";
                let pages = "";

                if ( current >= 6 && count > 9 ) {
                   leftDots += format(1, false);
                   leftDots += format("...", false);
                   pages += leftDots;
                }

                if (current + 4 < count && count > 9  ) {
                   rightDots += format("...", false);
                   rightDots += format(count, false);
                }

                let isFirst = false;
                let isLast = false;

                for (let numb = 1; numb <= count; numb++) {

                    let isCurrent = false;

                    if (numb === current) {
                        isCurrent = true;
                    }

                    if (leftDots || rightDots) {

                        let offSet = 2;

                        if (current === 1 || current === count) {
                            offSet = 3;
                        }

                        if ( leftDots && (current - numb) - offSet  > 0  ) {
                            continue;
                        }

                        if ( rightDots && (current - numb) + offSet < 0  ) {
                            continue;
                        }

                    }


                    pages += format(numb, isCurrent);

                    if (current === 1 && numb === current) {
                        isFirst = true;
                    }

                    if (current === count && numb === current) {
                        isLast = true;
                    }

                }

                if (rightDots) {
                    pages+=rightDots
                }

                DOMEl.wrap.innerHTML = formatPrevNext("<", isFirst) + pages + formatPrevNext(">", isLast);

            }

            return {
                set: function (data) {
                    payload.numPages = data.num_pages;
                    payload.page = data.current_page;
                    update();
                }
            }

        }
    });

